import { Map } from 'immutable';

export const getRoot = state => state.get('recommendation') || Map();

export const getRecommendationData = state => getRoot(state).get('data') || [];
